import { render, staticRenderFns } from "./AUI.vue?vue&type=template&id=50080773&"
import script from "./AUI.vue?vue&type=script&lang=js&"
export * from "./AUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports